import { Validator, ValidatorSchema } from '@libs/utilities/validator';


export const AGENT_WORKFLOW_OPERATIONS = ['search', 'set_filters', 'set_view', 'select', 'compare', 'read_history', 'add_favorites', 'export_csv', 'add_to_board', 'load_more', 'stop_search', 'navigate', 'check_listings', 'export_upload_batch', 'open_import', 'open_editor', 'show_upload_history'] as const;
export type TypeAgentWorkflowOperation = typeof AGENT_WORKFLOW_OPERATIONS[number];
export interface IAgentWorkflowCommand {
	operation: TypeAgentWorkflowOperation;
	searchTerm: string | null;
	filters: Array<{ name: string; value: string }>;
	ids: string[];
	view: 'grid_view' | 'list_view' | 'statistics' | null;
	destination: keyof typeof AGENT_WORKFLOW_DESTINATIONS | null;
}
export interface IAgentWorkflowSnapshot {
	route: string;
	pageTitle: string;
	pageData: string;
}
export interface IAgentWorkflowResult extends IAgentWorkflowSnapshot {
	stepId: string;
	status: string;
}
export class AgentWorkflowResultSchema implements ValidatorSchema<IAgentWorkflowResult> {
	stepId = Validator.String().isNotEmpty().isMaxLength(80);
	status = Validator.String().isNotEmpty().isMaxLength(2000);
	route = Validator.String().isNotEmpty().isMaxLength(500);
	pageTitle = Validator.String().isNotEmpty().isMaxLength(160);
	pageData = Validator.String().isMaxLength(20000);
}

/** Validate again on the client; model output never authorizes arbitrary UI or API calls. */
export function validateAgentWorkflowCommand(value: unknown): IAgentWorkflowCommand {
	if (!value || typeof value !== 'object') throw new Error('Invalid research action.');
	const c = value as IAgentWorkflowCommand;
	if (Object.keys(c).some((key) => !['operation', 'searchTerm', 'filters', 'ids', 'view', 'destination'].includes(key))
		|| !AGENT_WORKFLOW_OPERATIONS.includes(c.operation)
		|| !(c.searchTerm === null || (typeof c.searchTerm === 'string' && c.searchTerm.length <= 500))
		|| !Array.isArray(c.filters) || c.filters.length > 20
		|| c.filters.some((f) => !f || typeof f.name !== 'string' || f.name.length > 60 || typeof f.value !== 'string' || f.value.length > 500 || Object.keys(f).some((k) => k !== 'name' && k !== 'value'))
		|| !Array.isArray(c.ids) || c.ids.length > 50 || c.ids.some((id) => typeof id !== 'string' || !id || id.length > 100)
		|| ![null, 'grid_view', 'list_view', 'statistics'].includes(c.view)
		|| ![null, ...Object.keys(AGENT_WORKFLOW_DESTINATIONS)].includes(c.destination)) throw new Error('Invalid research action.');
	return c;
}

export const AGENT_WORKFLOW_DESTINATIONS = {
	'best-sellers': { route: '/research/research/best-sellers', title: 'Best Sellers' },
	'seller-trends': { route: '/research/research/seller-trends', title: 'Seller Trends' },
	'real-time-research': { route: '/research/research/real-time-research', title: 'Real Time Research' },
	'upload-designs': { route: '/upload/pod/design-management', title: 'Upload Designs' }
} as const;
